import(/* webpackMode: "eager" */ "/app/src/app/(client)/vote/page.tsx")